import React, { useEffect, useState } from 'react';
import { TextField, CircularProgress, MenuItem } from '@mui/material';
import * as empApi from '../../../../lib/api/employee';
import _ from 'lodash';
const HrPolicySelectbox = ({
  formik,
  name,
  label,
  variant,
  margin,
}) => {
  const [options, setOptions] = useState([]);
  const loading = options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      try {
        const response = await empApi.getHrPolicy({ useYn: 'Y' });
        if (response.data.list) {
          // const orderedList = _.sortBy(response.data.list, 'displayNo');
          // setOptions([...orderedList]);
          setOptions([...response.data.list]);
        }

      } catch (err) {
        console.log(err);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  return (
    <>
      {options.length > 0 ? (
        <TextField
          margin={margin !== null ? margin : ''}
          variant={variant !== null ? variant : 'outlined'}
          required
          fullWidth
          select
          id={name}
          name={name}
          label={label}
          value={formik.values[name] ? formik.values[name] : ''}
          onChange={(event) => {
            formik.setFieldValue(name, event.target.value);
          }}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        >
          {/* <MenuItem value="">{label}을 선택하세요</MenuItem>
      <Divider variant="middle"/> */}
          {options &&
            options.map((option, index) => (
              <MenuItem key={index} value={option.policyUuid}>
                {option.policyNm}
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <>
          <React.Fragment>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
          </React.Fragment>
        </>
      )}
    </>
  );
};

export default React.memo(HrPolicySelectbox);
